import React from "react";
import PropTypes from "prop-types";

import { CopyText } from "../CopyText";

import styles from "./ModalLegal.scss";

function LegalHeading({ children, ...otherProps }) {
  return (
    <CopyText
      variants={CopyText.Variant.highlight}
      customClass={styles.heading}
      {...otherProps}
    >
      {children}
    </CopyText>
  );
}

LegalHeading.propTypes = {
  children: PropTypes.node.isRequired,
};

LegalHeading.displayName = "ModalLegal.Heading";

export default LegalHeading;
